import UsageSpecificationPage from '@/views/leagal/UsageSpecificationPage'

export default function Page() {
  return <UsageSpecificationPage />
}
